import { gatewayInstance } from "@/server/gateway";
import pkg from "../../package.json";
const { REACT_APP_X_FLAG } = process.env;
enum osTypes {
  "WINDOWS" = 4,
  "MAC" = 5,
  "WEB" = 6
}

export async function checkUpgradeApp(
  version: string,
  platform: string,
  buildVersion = 0
): Promise<any> {
  // osType=4   windows；osType=5   mac；osType=6   web；

  try {
    const data = await gatewayInstance.request({
      api: "appVersionRpcService.getLatestVersion",
      method: "POST",
      body: { version, osType: osTypes[platform.toUpperCase() as any] || 4, buildVersion },
      headers: {
        "x-flag": REACT_APP_X_FLAG || (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID || "gwork",
        "x-app-version": process.env.APP_VERSION || pkg.version
      }
    });
    return [data, null];
  } catch (e) {
    return [null, e.message.toString()];
  }
}

// 检测下载队列
//  "downloadFlag":0/1 //下载标志，0-开始，1-结束
export async function checkDownloadAvailable ({
  downloadFlag
}: {
  downloadFlag: number;
}): Promise<any> {
  try {
    const data = await gatewayInstance.request({
      api: "appVersionRpcService.notifyDownload",
      method: "POST",
      body: { downloadFlag }
    });
    return [true, null];
  } catch (e) {
    return [null, e?.message?.toString()];
  }
}
